import { render, staticRenderFns } from "./ContestCriteriaOrderComponent.vue?vue&type=template&id=07f0ad2e"
import script from "./ContestCriteriaOrderComponent.vue?vue&type=script&lang=js"
export * from "./ContestCriteriaOrderComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports